import type { IonMenu } from '@ionic/angular';

export type IonMenuSyncResult = 'no-menu' | 'inactive' | 'already' | 'done' | 'failed';

/**
 * Drives the Ionic menu to the requested state and reports what happened.
 * `open()`/`close()` resolve `false` (rather than throw) when Ionic refuses the change,
 * so callers need the result to keep their own state in line with the real menu.
 */
export async function syncIonMenu(menu: IonMenu | undefined, shouldOpen: boolean): Promise<IonMenuSyncResult> {
  if (!menu) {
    return 'no-menu';
  }

  try {
    // Inactive while the split pane is showing the menu permanently (desktop) - nothing to open or close.
    if (!(await menu.isActive())) {
      return 'inactive';
    }
    if ((await menu.isOpen()) === shouldOpen) {
      return 'already';
    }
    const changed = shouldOpen ? await menu.open() : await menu.close();
    return changed ? 'done' : 'failed';
  } catch {
    return 'failed';
  }
}
